import { Paginate } from './pagination';
import { Sort } from './sorting';

export const Filter = (data, config) => {
    return Paginate(
        Sort(data, config.filters.sorting.sortByColumn, config.filters.sorting.sortByDescending),
        config.filters.pagination.paginationData.pageNumber,
        config.filters.pagination.paginationData.pageSize
    );
};
